import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const SIZES = {
  sm: { box: "rounded-xl px-4 py-9", icon: "h-6 w-6", title: "mt-2 text-[11px] leading-4", hint: "mt-1 text-[10px]" },
  md: { box: "rounded-2xl py-16", icon: "h-9 w-9", title: "mt-3 text-sm", hint: "mt-1 text-xs" },
  lg: { box: "rounded-2xl py-20", icon: "h-10 w-10", title: "mt-3 text-sm", hint: "mt-1 text-xs" },
} as const;

interface Props {
  icon?: LucideIcon;
  title: ReactNode;
  hint?: ReactNode;
  size?: keyof typeof SIZES;
  className?: string;
  children?: ReactNode;
}

export function EmptyState({ icon: Icon, title, hint, size = "lg", className, children }: Props) {
  const style = SIZES[size];
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center border border-dashed border-studio-border px-6 text-center",
        style.box,
        className
      )}
    >
      {Icon && <Icon className={cn("text-studio-faint", style.icon)} />}
      <p className={cn("text-studio-muted", style.title)}>{title}</p>
      {hint && <p className={cn("text-studio-faint", style.hint)}>{hint}</p>}
      {children}
    </div>
  );
}
